// The sprite content is auto-generated by generate-sprite.js
import { spriteContent } from './spriteContent';

let spriteInjected = false;

/**
 * Injects the SVG sprite into the DOM.
 * This is called automatically when the first Icon is rendered.
 * The sprite content is bundled with the library.
 */
export function injectSprite(): void {
  if (spriteInjected || typeof document === 'undefined') return;

  try {
    // Create a container for the sprite
    const container = document.createElement('div');
    container.style.display = 'none';
    container.setAttribute('aria-hidden', 'true');
    container.innerHTML = spriteContent;

    // Inject at the start of body
    if (document.body) {
      document.body.insertBefore(container, document.body.firstChild);
      spriteInjected = true;
    }
  } catch (error) {
    console.error('Error injecting sprite:', error);
  }
}

/**
 * Reset the injection state (useful for testing)
 */
export function resetSpriteInjection(): void {
  spriteInjected = false;
}
